import { useState } from "react";
import axios from "axios";
import { Loader2, ArrowRight } from "lucide-react";
import { AdminLayout } from "../AdminPages";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const input = "w-full rounded-lg border border-black/20 bg-transparent px-3 py-2 text-sm";

export default function AdminMergeAccounts() {
  const [from, setFrom] = useState("michael@reclaim.app");
  const [to, setTo] = useState("bookings@michaelmuller.co.uk");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  const run = async (dry) => {
    if (!dry && !window.confirm(`Move everything from ${from} into ${to}?`)) return;
    setBusy(dry ? "preview" : "merge"); setErr("");
    try { setRes((await axios.post(`${API}/api/admin/merge-accounts`, { from_email: from, to_email: to, dry_run: dry }, auth())).data); }
    catch (e) { setErr(e?.response?.data?.detail || "Couldn't merge just now."); }
    finally { setBusy(""); }
  };

  return (
    <AdminLayout title="Merge accounts">
      <div className="max-w-xl space-y-4" data-testid="merge-accounts-page">
        <p className="text-sm opacity-70">Moves every installation, recording, saved line and favourite from the first account into the second. The first account can still sign in, it will just be empty.</p>
        <label className="block text-xs uppercase tracking-widest opacity-60">Move from</label>
        <input className={input} value={from} onChange={(e) => setFrom(e.target.value)} data-testid="merge-from-email" />
        <div className="flex justify-center opacity-50"><ArrowRight size={16} /></div>
        <label className="block text-xs uppercase tracking-widest opacity-60">Into (keep)</label>
        <input className={input} value={to} onChange={(e) => setTo(e.target.value)} data-testid="merge-to-email" />
        <div className="flex gap-3 pt-2">
          <button onClick={() => run(true)} disabled={!!busy} data-testid="merge-preview-btn" className="rounded-full border border-black/30 px-5 py-2 text-sm">
            {busy === "preview" ? <Loader2 size={14} className="animate-spin" /> : "Preview"}
          </button>
          <button onClick={() => run(false)} disabled={!!busy || !res?.dry_run} data-testid="merge-confirm-btn" className="rounded-full bg-amber-300 text-black px-5 py-2 text-sm disabled:opacity-40">
            {busy === "merge" ? <Loader2 size={14} className="animate-spin" /> : "Merge now"}
          </button>
        </div>
        {err && <p className="text-sm text-red-600" data-testid="merge-error">{err}</p>}
        {res && (
          <div className="rounded-xl border border-black/10 p-4 text-sm" data-testid="merge-result">
            <p className="mb-2">{res.dry_run ? "Preview: would move" : "Moved"} <b data-testid="merge-total">{res.total_moved}</b> items · {res.from} → {res.to}</p>
            <ul className="max-h-72 overflow-auto text-xs opacity-80 space-y-0.5">
              {Object.entries(res.collections).map(([k, v]) => <li key={k}>{k} · {v.moved}{v.kept_destination ? ` (kept yours: ${v.kept_destination})` : ""}</li>)}
            </ul>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
